import { createContext, Dispatch, SetStateAction } from "react";

interface IModalStateContext {
  showSiteNewModal: boolean;
  serviceBillUid: string;
  // serviceList: any;
  detailIndex: number;
}
// 현재 open된 modal들을 나타냄.
export const ModalsStateContext = createContext<IModalStateContext>({
  showSiteNewModal: false,
  serviceBillUid: "", // 사이트 생성시 전달되는 serviceBillUid로 사용중 (2025-09-02)
  // serviceList: [],
  detailIndex: 0,
});

interface IModalsDispatchContext {
  openSiteNewModal: () => void;
  hideSiteNewModal: () => void;
  setShowSiteNewModal: Dispatch<SetStateAction<boolean>>;
  setServiceBillUid: Dispatch<SetStateAction<string>>;
  // setServiceList: Dispatch<SetStateAction<any>>;
  setDetailIndex: Dispatch<SetStateAction<number>>;
}

// modal을 열고 닫는 함수
export const ModalsDispatchContext = createContext<IModalsDispatchContext>({
  openSiteNewModal: () => {},
  hideSiteNewModal: () => {},
  setShowSiteNewModal: () => {},
  setServiceBillUid: () => {},
  // setServiceList: () => {},
  setDetailIndex: () => {},
});
